<template>
  <section id="choose-work"
           class="uk-margin-large-top uk-margin-medium-bottom uk-padding-large uk-padding-remove-horizontal"
           v-if="sortedWorks"
  >
    <div class="uk-container uk-container-large">
      <div class="uk-align-center uk-width-2-3">
        <h2 class="uk-h2">2. Orgelwerk w&auml;hlen</h2>
      </div>
    </div>

    <div class="uk-width-5-6 uk-align-center">
      <div class="uk-child-width-1-2@s uk-child-width-1-4@m uk-child-width-1-5@xl" data-uk-grid>
        <div v-for="w in sortedWorks" v-bind:key="w.id">
          <button class="uk-button uk-button-default uk-text-large"
                  v-on:click="setWork(w.id, w.title)"
                  v-bind:class="isSelected(w.id)"
          >{{w.title}}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {mapGetters} from 'vuex'
import {WORKS_QUERY} from '../../constants/graphql'
import _ from 'lodash'

export default {
  name: 'choose-work',
  data () {
    return {
      organ_work: {}
    }
  },
  apollo: {
    organ_work: {
      query: WORKS_QUERY
    }
  },
  computed: {
    sortedWorks () {
      return _.sortBy(this.organ_work.list, ['title'])
    },
    ...mapGetters(['chosenWork'])
  },
  methods: {
    setWork (id, title) {
      this.$store.dispatch('setWork', {id: id, title: title})
    },
    isSelected (id) {
      return this.chosenWork.id === id ? 'selected' : 'disabled'
    }
  }
}
</script>
<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";

  #choose-work {
    .uk-button-default {
      width: 100%;
      white-space: nowrap;
      @media (min-width: $breakpoint-medium) {
        padding: 3px 30px;
      }
      @media (min-width: $breakpoint-large) {
        padding: 3px 33px;
      }
      @media (min-width: $breakpoint-xlarge) {
        padding: 3px 50px;
      }
    }
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorPage/ChooseWork.vue